export const menuModifierOption = {
  merchant_supplied_id: '',
  name: '',
  active: true,
  price: 0,
  base_price: 0,
  original_image_url: '',
  active_stores: [],
};
